import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/XCircle.es.js";
const o = e.forwardRef((r, c) => /* @__PURE__ */ e.createElement(t, { ref: c, ...r, weights: a }));
o.displayName = "XCircleIcon";
const s = o;
export {
  s as XCircle,
  o as XCircleIcon
};
